module.exports = __webpack_public_path__ + "static/media/eco_system.873a7f3b.svg";